import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FaTrashAlt } from 'react-icons/fa'; // Importing the delete icon
import avatarImage from '../img/download (19).jpg'; // Imported image
import avatar3 from '../img/download (19).jpg'; // Profile image
import '../style/ProfileDashboard.css'; // Include the custom CSS for styling
import { useLocation, useNavigate } from 'react-router-dom';
import { getCarBookings } from '../Functions/apifunctions';
import moment from 'moment';
import { nf } from '../pages/Bookingpage';
import SimpleBackdrop from './SimpleBackdrop';
import api from '../api/api';

const ProfileDashboard = () => {
  const [account,setAccount]=useState(JSON.parse(localStorage.getItem('account'))||null);
  const navigate=useNavigate();
  const [carBookings, setCarBookings] = useState([]);
  const [loading,setLoading]=useState(false);
  const [tourBookings, setTourBookings] = useState([]);
  const [profileData, setProfileData] = useState({
    firstName: account.fullName.split(" ")[0],
    lastName: account.fullName.split(" ")[1],
    email: account.email,
    phone: account.phone,
    bio: '',
  });
  //fetch carbooking data
  const fetch_data=()=>{
    setLoading(true);
    getCarBookings(account._id).then((res)=>{
      setCarBookings(res.bookings);
      setLoading(false)
    })
  }
  const referesh=()=>{
    fetch_data();
  }
  useEffect(()=>{
    fetch_data();
  },[])



  

  const [isEditing, setIsEditing] = useState(false);
  const location=useLocation();
  const [activeSection, setActiveSection] = useState(location.state?.active||"personalInfo"); // Track active section

  const handleEditProfile = () => {
    setIsEditing(true);
  };

  const handleSaveChanges = () => {
    alert('Profile changes saved!');
    setIsEditing(false);  // Exit edit mode after saving
  };

  const handleChangePassword = () => {
    alert('Password change functionality here');
  };

  const handleDeleteCarBooking =async (bookingID) => {
  
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(async(result) => {
        if (result.isConfirmed) {
          setLoading(true);
          try {
            const response= await api.delete(`/bookings/${bookingID}`);
            if(response.data.success){
              Swal.fire({
                title: "Deleted!",
                text: "Your Booking has been deleted.",
                icon: "success"
              });
              referesh();
            }

            
          } catch (error) {
            console.log(error)
          }finally{
            setLoading(false);
          }
        }
      });
      
    
 
  };

  const handleDeleteTourBooking = (index) => {
    setTourBookings(tourBookings.filter((_, i) => i !== index));
  };
  useEffect(()=>{
    if(!account){
      navigate('/Login');
    }
  },[])

  return (
    <div className="bg-light "style={{paddingTop:"70px"}}>
      {loading && <SimpleBackdrop/>}
      <section className="welcome-hero-section ">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="welcome-heading">Welcome</h1>
            </div>
            {/* <div className="col-md-4 text-center">
              <img
                src={avatarImage}  // Use the imported image
                alt="Avatar"
                className="welcome-avatar rounded-circle"
              />
            </div> */}
          </div>
        </div>
      </section>

      <Container className="py-3">
        <Row>
          <Col sm={12} md={3}>
            <div className="profile-sidebar">
              <div className="p-4">
                <div className="nav flex-column nav-pills">
                  <Button variant="link" className='bg-white text-decoration-none mt-2 ' onClick={() => setActiveSection('personalInfo')}>
                    <i className="fas fa-user me-2"></i> Personal Info
                  </Button>
                  <Button variant="link"  className='bg-white text-decoration-none mt-2 ' onClick={() => setActiveSection('carBookings')}>
                    <i className="fas fa-car me-2"></i> Your Car Bookings
                  </Button>
                  <Button variant="link"  className='bg-white text-decoration-none mt-2 ' onClick={() => setActiveSection('tourBookings')}>
                    <i className="fas fa-suitcase me-2"></i> Your Tour Bookings
                  </Button>
                  <Button variant="link"  className='bg-white text-decoration-none mt-2 ' onClick={handleEditProfile}>
                    <i className="fas fa-edit me-2"></i> Edit Profile
                  </Button>
                  <Button variant="link"  className='bg-white text-decoration-none mt-2 ' onClick={handleChangePassword}>
                    <i className="fas fa-lock me-2"></i> Change Password
                  </Button>
                  <Button variant="link"  className='bg-white text-decoration-none mt-2 ' onClick={() => setActiveSection('dashboard')}>
                    <i className="fas fa-tachometer-alt me-2"></i> Dashboard
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col sm={12} md={9}>
            <div className="card border-0 shadow">
              <div className="card-body">
                <div className="profile-header position-relative mb-4">
                  <div className="position-absolute top-0 end-0 p-3">
                   
                  </div>
                </div>
                <div className="text-center">
                  <img
                    src={avatar3} // Profile image
                    className="rounded-circle profile-pic"
                    alt="Profile"
                  />
                  <h3 className="mt-3 mb-1">{profileData.firstName} {profileData.lastName}</h3>
                </div>

                {/* Personal Information Section */}
                {activeSection === 'personalInfo' && (
                  <div>
                    <h5 className="mb-4">Personal Information</h5>
                    <Form>
                      <Row>
                        <Col md={6}>
                          <Form.Group controlId="formFirstName">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileData.firstName}
                              readOnly={!isEditing}
                              onChange={(e) => setProfileData({ ...profileData, firstName: e.target.value })}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group controlId="formLastName">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={profileData.lastName}
                              readOnly={!isEditing}
                              onChange={(e) => setProfileData({ ...profileData, lastName: e.target.value })}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group controlId="formEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              value={profileData.email}
                              readOnly={!isEditing}
                              onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group controlId="formPhone">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              type="tel"
                              value={profileData.phone}
                              readOnly={!isEditing}
                              onChange={(e) => setProfileData({ ...profileData, phone: e.target.value })}
                            />
                          </Form.Group>
                        </Col>
                       
                      </Row>
                    </Form>
                    {isEditing && (
                      <Button variant="primary" className="mt-3" onClick={handleSaveChanges}>
                        Save Changes
                      </Button>
                    )}
                  </div>
                )}

                {/* Car Bookings Section */}
                {activeSection === 'carBookings' && (
                  <div>
                    <h5 className="mb-4 text-center mt-4">Your Car Bookings</h5>
                    <div className="count-board w-100">
                      <div className="count-card w-100">
                        <h6>Total Bookings</h6>
                        <p>{carBookings.length}</p>
                      </div>
                    </div>
                    {carBookings.map((booking, index) =>{ 
                      const startDate=moment(booking.startDate);
                      const endDate=startDate.clone().add(booking.durationDays,'day') 
                    return(
                      <div key={index} className="car-booking-item mb-4">
                        <div className="car-booking-header d-flex align-items-center">
                          <img
                            src={`http://localhost:8000${booking?.carId?.mainImage}`} // Placeholder for car image. Replace with actual car image URL.
                            alt={booking.carId.name}
                            className="rounded car-image me-3"
                          />
                          <div>
                            <h6>{booking?.carId.name}</h6>
                            <p>{moment(booking?.startDate).format('DD-MMM-YYYY')}</p>
                          </div>
                         {booking.status=="pending"&& <Button 
                            variant="link" 
                            className="ms-auto" 
                            onClick={() => handleDeleteCarBooking(booking._id)}
                          >
                            <FaTrashAlt /> {/* Delete Icon */}
                          </Button>}
                        </div>
                        <ul className="list-unstyled">
                          <li className='text-success '><strong className='text-dark'>Total Booking Price:  </strong><span className='fw-bold'>{nf.format(booking.totalPrice)}</span></li>
                          <li><strong>Start Date:</strong> {moment(booking?.startDate).format('DD-MMM-YYYY')}</li>
                          <li><strong>End Date:</strong> {moment(endDate).format('DD-MMM-YYYY')}</li>
                          <li><strong>Phone:</strong> {profileData.phone}</li>
                          <li><strong>Status:</strong> {booking.status}</li>
                        </ul>
                        <div className="booking-note">
                          <p><strong>Booking Note:</strong> Please bring your driving license upon pickup.</p>
                        </div>
                      </div>
                    )})}
                  </div>
                )}

                {/* Tour Bookings Section */}
                {activeSection === 'tourBookings' && (
                  <div>
                    <h5 className="mb-4">Your Tour Bookings</h5>
                    <div className="count-board">
                      <div className="count-card">
                        <h6>Total Bookings</h6>
                        <p>{tourBookings.length}</p>
                      </div>
                    </div>
                    {tourBookings.map((booking, index) => (
                      <div key={index} className="tour-booking-item mb-4">
                        <div className="tour-booking-header d-flex align-items-center">
                          <img
                            src={`https://via.placeholder.com/100`} // Placeholder for tour image. Replace with actual tour image URL.
                            alt={booking.tour}
                            className="rounded-circle tour-image me-3"
                          />
                          <div>
                            <h6>{booking.tour}</h6>
                            <p>{booking.date}</p>
                          </div>
                          <Button 
                            variant="link" 
                            className="ms-auto" 
                            onClick={() => handleDeleteTourBooking(index)}
                          >
                            <FaTrashAlt /> {/* Delete Icon */}
                          </Button>
                        </div>
                        <ul className="list-unstyled">
                          <li><strong>Total Price:</strong> $1500</li>
                          <li><strong>Start Date:</strong> {booking.date}</li>
                          <li><strong>Booking Date:</strong></li>
                          <li><strong>Phone:</strong> {profileData.phone}</li>
                          <li><strong>Status:</strong> {booking.status}</li>
                        </ul>
                        <div className="booking-note">
                          <p><strong>Booking Note:</strong> Please bring your ID and confirmation email upon arrival.</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Dashboard Section */}
                {activeSection === 'dashboard' && (
                  <div>
                    <h5 className="mb-4">Dashboard</h5>
                    <div className="count-board">
                      <div className="count-card">
                        <h6>Total Car Bookings</h6>
                        <p>{carBookings.length}</p>
                      </div>
                      <div className="count-card">
                        <h6>Total Tour Bookings</h6>
                        <p>{tourBookings.length}</p>
                      </div>
                      <div className="count-card">
                        <h6>Total Bookings</h6>
                        <p>{carBookings.length + tourBookings.length}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileDashboard;
